module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAWBAMAAABanCMNAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTDp2/zx2/zx3/0hs/zp2/zp0/0Zw/zx2/zx2/zp1/z52/zx2/4d42toAAAAMdFJOUwDR7WkGhb0S3aUzUtkqPV8AAABgSURBVBjTY2BAAguVGdDBnDMGmEKH0YUcz2AoY5fBVFZIgrJlgshA4syZ0ww9Z9DACQYdTKGNSijgDIb5bmfOhKCKsOScOYqpKIAMRQwxGIqA4YWuiGURhp8ZWFwYsAMA8c9C+z4lNT8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_icon_03_zh.png
// module id = vuww
// module chunks = 34